interface StarRatingProps {
  rating: number;
  count?: number;
  className?: string;
}

export function StarRating({ rating, count, className = '' }: StarRatingProps) {
  const rounded = Math.max(0, Math.min(5, Math.round(rating * 2) / 2));

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div
        className="flex gap-0.5"
        role="img"
        aria-label={`Rated ${rating.toFixed(1)} out of 5${count ? ` from ${count} ratings` : ''}`}
      >
        {Array.from({ length: 5 }).map((_, i) => {
          const fill = Math.max(0, Math.min(1, rounded - i));
          return (
            <span key={i} className="relative inline-block w-3 h-3" aria-hidden="true">
              <svg viewBox="0 0 20 20" className="absolute inset-0 w-full h-full text-ink-900/15" fill="currentColor">
                <path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.2 1 5.9L10 14.9l-5.2 2.9 1-5.9L1.5 7.7l5.9-.8z" />
              </svg>
              <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
                <svg viewBox="0 0 20 20" className="w-3 h-3 text-accent-yellow" fill="currentColor">
                  <path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.2 1 5.9L10 14.9l-5.2 2.9 1-5.9L1.5 7.7l5.9-.8z" />
                </svg>
              </span>
            </span>
          );
        })}
      </div>
      {typeof count === 'number' && (
        <span className="text-xs text-ink-500">{count.toLocaleString()} ratings</span>
      )}
    </div>
  );
}
